import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "info_card info_card__danger info_card__header mb-4 flex-md-row flex-column"
}
const _hoisted_2 = { class: "text-decoration-underline" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "header-wrapper" }
const _hoisted_5 = { class: "header-navigation" }
const _hoisted_6 = { class: "plan-modal my-profile-wrapper" }
const _hoisted_7 = { class: "header-notifications" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-Bell" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "notification-count"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " Notifications ", -1)
const _hoisted_11 = {
  key: 0,
  class: "profile-dropdown-menu align-items-center notifications"
}
const _hoisted_12 = { class: "d-flex justify-content-between w-100 pdr-15 pdl-15" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "fw-semibold" }, "Notifications", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "divider w-100 divider_horizontal mb-0 mt-10" }, null, -1)
const _hoisted_15 = { class: "notifications-alerts w-100 gap-10" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-Settings" }, null, -1)
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-call-calling" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_21 = { class: "plan-modal my-profile-wrapper" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-user-rounded" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow-down" }, null, -1)
const _hoisted_24 = { class: "profile-dropdown-menu" }
const _hoisted_25 = ["href"]
const _hoisted_26 = ["href"]
const _hoisted_27 = {
  key: 0,
  class: "plus iatse-icon-plus"
}
const _hoisted_28 = {
  key: 1,
  class: "line"
}
const _hoisted_29 = {
  key: 0,
  class: "dashboard-details mt-45 card-toggle"
}
const _hoisted_30 = {
  key: 0,
  class: "divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_InfoCard = _resolveComponent("InfoCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isImpersonating)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", null, [
            _createTextVNode(" You are currently masquerading "),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.impersonationName), 1)
          ]),
          _createElementVNode("button", {
            class: "btn btn-small btn-outlined",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.terminateImpersonation && _ctx.terminateImpersonation(...args)))
          }, "Stop masquerading")
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("header", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", {
              class: _normalizeClass([{ 'pdl-10': _ctx.isLocal || _ctx.isEmployer }])
            }, " Hello, " + _toDisplayString(_ctx.isImpersonating ? _ctx.impersonationName : _ctx.userName) + "! ", 3),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "plan-modal",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('alerts', 'Alerts', null)))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    (_ctx.unreadAlerts)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.unreadAlerts), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_10
                ]),
                (_ctx.alerts.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        (_ctx.unreadAlerts)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              class: "fs-sm text-medium-grey",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.readNotifications && _ctx.readNotifications(...args)))
                            }, "Mark all as read"))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_AlertsComponent, {
                          max: 10,
                          read: _ctx.readAll,
                          "show-unread": true,
                          onRead: _ctx.readNotifications
                        }, null, 8, ["read", "onRead"])
                      ]),
                      _createElementVNode("p", {
                        class: "plan-modal justify-content-center fs-sm fw-semibold w-100 text-center pdt-20",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal('alerts', 'Alerts', null)))
                      }, "View All Notifications")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_16,
              (!_ctx.isLocal && !_ctx.isEmployer)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModal('account-settings', 'Account Settings', 'plan-card-info'))),
                    class: "plan-modal"
                  }, [
                    _hoisted_17,
                    _createTextVNode("Account Settings ")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isLocal || _ctx.isEmployer)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "plan-modal",
                    href: `${_ctx.baseUrl}/en/contact`,
                    target: "_blank"
                  }, [
                    _hoisted_19,
                    _createTextVNode("Contact")
                  ], 8, _hoisted_18))
                : _createCommentVNode("", true),
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("p", {
                  class: "plan-modal",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleLocalProfileOpen && _ctx.handleLocalProfileOpen(...args)))
                }, [
                  _hoisted_22,
                  _createTextVNode(" My Profile "),
                  _hoisted_23
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_ctx.isParticipant)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "plan-modal",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleProfileOpen && _ctx.handleProfileOpen(...args)))
                      }, "Profile Settings"))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    class: "plan-modal",
                    href: `${_ctx.baseUrl}/en/contact`,
                    target: "_blank"
                  }, "Help & Support", 8, _hoisted_25),
                  _createElementVNode("a", {
                    class: "plan-modal",
                    href: `${_ctx.baseUrl}/en/privacy-policy`,
                    target: "_blank"
                  }, "Privacy Policy", 8, _hoisted_26),
                  _createElementVNode("p", {
                    class: "plan-modal",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.performLogout && _ctx.performLogout(...args)))
                  }, "Log Out")
                ])
              ])
            ]),
            (_ctx.isParticipant)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["card-control", { 'plus': !_ctx.visibleContent }]),
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleVisible && _ctx.toggleVisible(...args)))
                }, [
                  (!_ctx.visibleContent)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                    : _createCommentVNode("", true),
                  (_ctx.visibleContent)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              (_ctx.visibleContent && _ctx.isParticipant )
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboardItems, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.title,
                        class: "dashboard-detail-item pdl-0"
                      }, [
                        _createVNode(_component_InfoCard, {
                          iconClass: item.iconClass,
                          title: item.title,
                          detail: item.detail,
                          error: item.error
                        }, null, 8, ["iconClass", "title", "detail", "error"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.dashboardItems && _ctx.isParticipant)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}